export const VERSION_ONE = "1";
export const VERSION_TWO = "2";
export const VERSION_THREE = "3";

export interface WidgetProps {
    version?: string;
}
